
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotels/[id]/[slug]",
      function () {
        return require("private-next-pages/hotels/[id]/[slug].tsx");
      }
    ]);
  